// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon('eva:pie-chart-2-fill'),
  },
  {
    title: 'customers',
    path: '/dashboard/customers',
    icon: getIcon('eva:people-fill'),
  },
  {
    title: 'inventory',
    path: '/dashboard/inventory',
    icon: getIcon('eva:shopping-bag-fill'),
  },
  {
    title: 'History',
    path: '/dashboard/history',
    icon: getIcon('eva:calendar-fill'),
  },
  {
    title: 'documentation',
    path: '/dashboard/documentation',
    icon: getIcon('eva:file-text-fill'),
  },
];

export default navConfig;
